$component-class: 'sn-stats-type-1';

.#{$component-class} {
  .me-row .me-column {
    padding: 0;
  }

  @include below-desktop {
    .stats-type-6__counters {
      grid-template-columns: 1fr;
      gap: var(--spacing-md);
    }

    .stats-counter-card-type-3 {
      padding: var(--spacing-md);
    }

    .stats-counter-card-type-3__counter {
      font-size: 2rem;
      margin-bottom: var(--spacing-sm);
    }

    .stats-counter-card-type-3__caption .me-heading {
      margin-bottom: var(--spacing-md);
    }
  }
}
